import React, { useState, useEffect } from 'react';

const CONF_COLORS = {
  high: '#059669',
  medium: '#d97706',
  low: '#dc2626',
};

export default function FieldRow({
  fieldKey,
  label,
  value,
  displayValue,
  confidence,
  band = 'medium',
  edited = false,
  mono = false,
  editedMeta,
  enrichmentLabel = null,
  canEdit = false,
  onSave,
  onHighlight,
  active = false,
}) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(value ?? '');

  useEffect(() => {
    if (!editing) {
      setVal(value ?? '');
    }
  }, [value, editing]);

  const shown = displayValue ?? value ?? '—';

  const handleBlur = () => {
    setEditing(false);
    if (String(val) !== String(value ?? '') && onSave) {
      onSave(fieldKey, val);
    }
  };

  return (
    <div
      className={`dv-field-row${active ? ' dv-field-row--active' : ''}${band === 'low' ? ' dv-field-row--low' : ''}`}
      data-band={band}
      onClick={() => onHighlight?.(fieldKey)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onHighlight?.(fieldKey)}
    >
      <span className="dv-field-label">{label}</span>
      {editing ? (
        <input
          className="dv-field-input"
          value={val}
          autoFocus
          onChange={(e) => setVal(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={(e) => e.key === 'Enter' && e.target.blur()}
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <span className={`dv-field-value${mono ? ' mono' : ''}`}>
          {shown}
          {edited && (
            <span
              className="dv-field-edited"
              title={
                editedMeta?.original_value != null
                  ? `Original: ${editedMeta.original_value}`
                  : 'Editado'
              }
            >
              editado
            </span>
          )}
          {enrichmentLabel && (
            <span className="dv-field-enriched" title="Completado automáticamente por baja confianza en extracción">
              {enrichmentLabel}
            </span>
          )}
        </span>
      )}
      <span
        className="dv-field-conf"
        style={{ background: CONF_COLORS[band] || CONF_COLORS.medium }}
        title={confidence != null ? `Confianza ${Math.round(confidence * 100)}%` : undefined}
      />
      {canEdit && !editing && (
        <button
          type="button"
          className="dv-field-edit"
          aria-label={`Editar ${label}`}
          onClick={(e) => {
            e.stopPropagation();
            setVal(value ?? '');
            setEditing(true);
          }}
        >
          ✎
        </button>
      )}
    </div>
  );
}
